import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHelper } from '../Common/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class SubscriptionService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // PACKAGE MASTER------------------------------------------------------ 

  SavePackage(strdata: any): Observable<any> {
    let Parameter = 'objPackage=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SavePackage?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }
  PackageMarkActive(strdata: any): Observable<any> {
    let Parameter = 'objPackage=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/PackageMarkActive?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  GetAllPackage(strdata: any): Observable<any> {
    let Parameter = 'objPackage=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetAllPackage?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

// CURRENCY

GetAllCurrency(strdata: any): Observable<any> {
  let Parameter = 'objPackage=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetAllCurrency?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}
SaveCurrency(strdata: any): Observable<any> {
  let Parameter = 'objPackage=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SaveCurrency?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}

GetCurrencyLog(strdata: any): Observable<any> {
  let Parameter = 'CurrencyID=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetCurrencyLog?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}
  // FEATURE MASTER------------------------------------------------------ 

  SavePackageFeature(strdata: any): Observable<any> {
    let Parameter = 'objFeature=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SavePackageFeature?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }
  FeatureMarkActive(strdata: any): Observable<any> {
    let Parameter = 'objFeature=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/FeatureMarkActive?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  GetAllPackageFeature(strdata: any): Observable<any> {
    let Parameter = 'objFeature=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetAllPackageFeature?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  // PACKAGE SITE MAP 


  SavePackageSiteMap(PackageID, List): Observable<any> {
    let formData = new FormData();
    formData.append("PackageID", PackageID);
    formData.append("ListPackageSiteMap", List);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SavePackageSiteMap', formData);
  }

  GetAllPackageSiteMap(strdata: any): Observable<any> {
    let Parameter = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetAllPackageSiteMap?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  // SUBSCRIPTION BRANCH MAPPING

  GetAllSubscription(strdata: any): Observable<any> {
    let Parameter = 'objSubscription=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetAllSubscription?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  SubscriptionMarkActive(strdata: any): Observable<any> {
    let Parameter = 'objSubscription=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SubscriptionMarkActive?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  SaveSubscription(strdata: any): Observable<any> {
    let Parameter = 'objSubscription=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SaveSubscription?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }
  SuperAdminRegisterSchool(strdata, datalist): Observable<any> {
    let formData = new FormData();
    formData.append("strdata", strdata);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SuperAdminRegisterSchool', formData);
  }
  CheckUserExists(Email): Observable<any> {
    let formData = new FormData();
    formData.append("Email", Email);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ChannelPartner/CheckUserExists', formData);
  }
  CheckBranchCodeExists(BranchCode): Observable<any> {
    let formData = new FormData();
    formData.append("BranchCode", BranchCode);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ChannelPartner/CheckBranchCodeExists', formData);
  }
  // MOBILE PACKAGE SITE MAP


  SaveMobilePackageSiteMap(objSubscription, List): Observable<any> {
    let formData = new FormData();
    formData.append("objSubscription", objSubscription);
    formData.append("ListPackageSiteMap", List);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SaveMobilePackageSiteMap', formData);
  }

  GetAllMobilePackageSiteMap(strdata: any): Observable<any> {
    let Parameter = 'objSubscription=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetAllMobilePackageSiteMap?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

 // Matrix MASTER------------------------------------------------------ 
 RemoveCountry(objSubscription,List): Observable<any> {
    
  let formData = new FormData();
formData.append("strdata", objSubscription);
formData.append("List", List);
return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/RemoveCountry', formData);

}
ADDCountry(objSubscription,List): Observable<any> {
    
  let formData = new FormData();
formData.append("strdata", objSubscription);
formData.append("List", List);
return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/ADDCountry', formData);

}
 SaveGroupCountry(strdata: any): Observable<any> {
  let Parameter = 'strdata=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SaveGroupCountry?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}
GetCountry(strdata: any): Observable<any> {
  let Parameter = 'strdata=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetCountry?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}
GetSelectCountry(strdata: any): Observable<any> {
  let Parameter = 'strdata=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetSelectCountry?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}
GetAllGroupCountry(strdata: any): Observable<any> {
  let Parameter = 'strdata=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetAllGroupCountry?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}
 SavePackageMatrix(strdata: any): Observable<any> {
  let Parameter = 'objMatrix=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SavePackageMatrix?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}
MatrixMarkActive(strdata: any): Observable<any> {
  let Parameter = 'objMatrix=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/MatrixMarkActive?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}

GetAllPackageMatrix(strdata: any): Observable<any> {
  let Parameter = 'objMatrix=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetAllPackageMatrix?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}


  // FEATURE MASTER------------------------------------------------------ 

  SavePackageSale(objSubscription,List): Observable<any> {
    
      let formData = new FormData();
    formData.append("objSubscription", objSubscription);
    formData.append("List", List);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SavePackageSale', formData);
 
  }
  SaleMarkActive(strdata: any): Observable<any> {
    let Parameter = 'objFeature=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SaleMarkActive?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  GetPackageSale(strdata: any): Observable<any> {
    let Parameter = 'objSale=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetPackageSale?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }
  GetPackagePrice(strdata: any): Observable<any> {
    let Parameter = 'objPrice=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/GetPackagePrice?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }
  
  SavePackagePrice(objSubscription, List): Observable<any> {
    let formData = new FormData();
    formData.append("objSubscription", objSubscription);
    formData.append("List", List);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Subscription/SavePackagePrice', formData);
  }

}
